module.exports = __webpack_public_path__ + "static/media/Break.4268008c.svg";